(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["topscamis-cart-promotions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('topscamis-cart-countdown')) {
    customElements.define(
      'topscamis-cart-countdown',
      class extends HTMLElement {
        static storageKey = 'topscamis_cart_reservation_expires_at';
        static duration = 15 * 60 * 1000;

        connectedCallback() {
          this.stopTimer();

          if (this.dataset.cartEmpty === 'true') {
            this.clearExpiration();
            return;
          }

          this.output = this.querySelector('[data-cart-countdown]');

          if (!this.output) return;

          let expiration = this.readExpiration();

          if (!Number.isFinite(expiration) || expiration <= Date.now()) {
            expiration = Date.now() + this.constructor.duration;
            this.saveExpiration(expiration);
          }

          this.expiration = expiration;
          this.updateTimer();

          this.intervalId = window.setInterval(() => {
            this.updateTimer();
          }, 1000);
        }

        disconnectedCallback() {
          this.stopTimer();
        }

        readExpiration() {
          try {
            return Number(
              window.localStorage.getItem(this.constructor.storageKey)
            );
          } catch (error) {
            return Number(this.dataset.fallbackExpiration || 0);
          }
        }

        saveExpiration(expiration) {
          this.dataset.fallbackExpiration = String(expiration);

          try {
            window.localStorage.setItem(
              this.constructor.storageKey,
              String(expiration)
            );
          } catch (error) {
            // El temporizador continúa aunque el navegador bloquee localStorage.
          }
        }

        clearExpiration() {
          delete this.dataset.fallbackExpiration;

          try {
            window.localStorage.removeItem(this.constructor.storageKey);
          } catch (error) {
            // No es necesario realizar ninguna acción adicional.
          }
        }

        stopTimer() {
          if (!this.intervalId) return;

          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }

        updateTimer() {
          const remainingSeconds = Math.max(
            0,
            Math.ceil((this.expiration - Date.now()) / 1000)
          );

          const minutes = Math.floor(remainingSeconds / 60);
          const seconds = remainingSeconds % 60;

          this.output.textContent =
            String(minutes).padStart(2, '0') +
            ':' +
            String(seconds).padStart(2, '0');

          this.output.setAttribute(
            'datetime',
            `PT${minutes}M${seconds}S`
          );

          if (remainingSeconds === 0) {
            this.stopTimer();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
